import {
    GET_BRAINCHIP_RECIPES_LOADING,
    GET_BRAINCHIP_RECIPES_SUCCESS,
    GET_BRAINCHIP_RECIPES_FAILURE
} from '../actionTypes'
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';
import { getRecursivelyAsync } from '../../utils/get-recursively-async';

export const getBrainchipRecipesSuccess = payload => ({
    type: GET_BRAINCHIP_RECIPES_SUCCESS,
    payload
})

export const getBrainchipRecipesFailure = () => ({
    type: GET_BRAINCHIP_RECIPES_FAILURE
})

export const getBrainchipRecipesAsync = payload => dispatch => {
    return dispatch(getRecursivelyAsync('brainchip-recipes', getBrainchipRecipesSuccess, 0));
}